document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const toggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

if (toggle && mobileMenu) {
  let menuContentTimer;

  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    clearTimeout(menuContentTimer);
    document.body.classList.remove('menu-content-return');
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.setAttribute('aria-label', open ? 'Menü öffnen' : 'Menü schließen');
    mobileMenu.setAttribute('aria-hidden', String(open));

    if (open) {
      document.body.classList.add('menu-content-return');
      document.body.classList.remove('menu-open');
      menuContentTimer = window.setTimeout(() => document.body.classList.remove('menu-content-return'), 600);
    } else {
      document.body.classList.add('menu-open');
    }
  });

  mobileMenu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Menü öffnen');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
    });
  });
}

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', (event) => {
    const option = event.target.options[event.target.selectedIndex];
    const price = option.dataset.price;
    const available = option.dataset.available === 'true';
    const form = event.target.closest('form');
    const button = form?.querySelector('[data-add-to-cart]');
    const priceElement = document.querySelector('[data-product-price]');

    if (priceElement && price) priceElement.textContent = price;
    if (button) {
      button.disabled = !available;
      button.textContent = available ? button.dataset.label : button.dataset.soldOutLabel;
    }
  });
});

const heroParallax = document.querySelector('[data-hero-parallax]');

if (heroParallax && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const hero = heroParallax.closest('.hero');
  const strength = Number.parseFloat(heroParallax.dataset.parallaxStrength) || 0.18;
  let heroParallaxFrame;

  const updateHeroParallax = () => {
    heroParallaxFrame = null;

    const heroRect = hero.getBoundingClientRect();
    const scrollProgress = Math.min(Math.max(-heroRect.top, 0), heroRect.height);
    const offset = -scrollProgress * strength;

    heroParallax.style.setProperty('--hero-parallax-y', `${offset.toFixed(2)}px`);
  };

  const requestHeroParallax = () => {
    if (heroParallaxFrame) return;
    heroParallaxFrame = requestAnimationFrame(updateHeroParallax);
  };

  updateHeroParallax();
  window.addEventListener('scroll', requestHeroParallax, { passive: true });
  window.addEventListener('resize', requestHeroParallax);
  window.addEventListener('pageshow', requestHeroParallax);
}

const loadFadeTitle = document.querySelector('[data-load-fade]');

if (loadFadeTitle) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => loadFadeTitle.classList.add('is-load-visible'));
  });
}

const reduceScrollTyping = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('[data-scroll-typing-block]').forEach((scrollTypingBlock) => {
  if (reduceScrollTyping) return;

  const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);
  const typingItems = [...scrollTypingBlock.querySelectorAll('[data-scroll-type]')];
  const triggerPoint = Number.parseFloat(scrollTypingBlock.dataset.scrollStart) || 0.92;
  const randomDirections = scrollTypingBlock.hasAttribute('data-scroll-random-direction');
  let typingFrame;

  typingItems.forEach((item, itemIndex) => {
    const text = item.textContent.trim();
    const lineRevealMode = item.dataset.scrollMode === 'line';
    const direction = randomDirections ? (Math.random() < 0.5 ? -1 : 1) : (itemIndex % 2 === 0 ? -1 : 1);
    item.classList.add('scroll-type');
    item.setAttribute('aria-label', text);
    item.dataset.scrollDirection = String(direction);

    if (lineRevealMode) {
      item.classList.add('scroll-type--line');
      if (direction === 1) item.classList.add('scroll-type--from-right');
    } else {
      const visualText = document.createElement('span');

      item.textContent = '';
      visualText.className = 'scroll-type__visual';
      visualText.setAttribute('aria-hidden', 'true');

      [...text].forEach((character) => {
        if (character === ' ') {
          visualText.append(document.createTextNode(' '));
          return;
        }

        const characterElement = document.createElement('span');
        characterElement.className = 'scroll-type__char';
        characterElement.textContent = character;
        visualText.append(characterElement);
      });

      item.append(visualText);
    }

    const button = item.closest('.button');

    if (button) {
      button.classList.add('button--draw-scroll');

      ['top', 'right', 'bottom', 'left'].forEach((side) => {
        const border = document.createElement('span');
        border.className = `draw-border draw-border--${side}`;
        border.setAttribute('aria-hidden', 'true');
        button.append(border);
      });
    }
  });

  const updateScrollTyping = () => {
    typingFrame = null;
    const viewportHeight = window.innerHeight;

    typingItems.forEach((item, itemIndex) => {
      const rect = item.getBoundingClientRect();
      const delay = Math.min(itemIndex * 0.01, 0.07) * viewportHeight;
      const progress = clamp((viewportHeight * triggerPoint - rect.top - delay) / (viewportHeight * 0.13), 0, 1);
      const easedProgress = progress * progress * (3 - 2 * progress);
      const direction = Number(item.dataset.scrollDirection) || 1;
      const shift = direction * (1 - easedProgress) * 28;

      item.style.setProperty('--type-shift', `${shift.toFixed(2)}px`);

      if (item.dataset.scrollMode === 'line') {
        item.style.setProperty('--line-hidden', `${((1 - progress) * 100).toFixed(2)}%`);
      } else {
        const characters = [...item.querySelectorAll('.scroll-type__char')];

        characters.forEach((character, characterIndex) => {
          const characterProgress = clamp(progress * (characters.length + 3) - characterIndex, 0, 1);
          character.style.setProperty('--char-opacity', characterProgress.toFixed(4));
        });
      }

      const button = item.closest('.button--draw-scroll');

      if (button) {
        [...button.querySelectorAll('.draw-border')].forEach((border, borderIndex) => {
          const borderProgress = clamp(progress * 4 - borderIndex, 0, 1);
          border.style.setProperty('--draw-progress', borderProgress.toFixed(4));
        });
      }
    });
  };

  const requestScrollTyping = () => {
    if (typingFrame) return;
    typingFrame = requestAnimationFrame(updateScrollTyping);
  };

  updateScrollTyping();
  window.addEventListener('scroll', requestScrollTyping, { passive: true });
  window.addEventListener('resize', requestScrollTyping);
  window.addEventListener('pageshow', requestScrollTyping);
});

document.querySelectorAll('[data-new-projects]').forEach((container) => {
  [...container.children]
    .sort((firstProject, secondProject) => Number(secondProject.dataset.projectOrder) - Number(firstProject.dataset.projectOrder))
    .forEach((project) => container.append(project));
});

const projectRows = document.querySelectorAll('.showcase-row');

if (projectRows.length) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);
  const firstProjectRow = projectRows[0];
  const projectTitles = [...document.querySelectorAll('.showcase-row__content h2')];
  const projectSubtitles = [...document.querySelectorAll('.showcase-row__subtitle')];
  const projectPageHeading = document.querySelector('.project-showcase__header h1');
  let requestProjectReveal = () => {};
  let prepareProjectTyping = () => {};

  const getProjectTitleLines = (title) => {
    const textNode = [...title.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
    const words = [...(textNode?.textContent ?? '').matchAll(/\S+/g)];

    if (!textNode || !words.length) return [];

    const range = document.createRange();
    const lines = [];

    words.forEach((word) => {
      range.setStart(textNode, word.index);
      range.setEnd(textNode, word.index + word[0].length);

      const rect = range.getBoundingClientRect();
      let line = lines.find((candidate) => Math.abs(candidate.top - rect.top) < 2);

      if (!line) {
        line = { top: rect.top, words: [word[0]] };
        lines.push(line);
      } else {
        line.words.push(word[0]);
      }
    });

    range.detach();
    return lines.map((line) => line.words.join(' '));
  };

  const fitProjectTitles = () => {
    projectTitles.forEach((title) => {
      const originalText = title.dataset.fitText || title.textContent.trim();
      title.dataset.fitText = originalText;
      title.textContent = originalText;
      title.style.removeProperty('font-size');

      const targetWidth = title.clientWidth;
      const baseFontSize = Number.parseFloat(getComputedStyle(title).fontSize);
      const lines = getProjectTitleLines(title);

      if (!targetWidth || !baseFontSize || !lines.length) return;

      title.textContent = '';

      lines.forEach((lineText) => {
        const line = document.createElement('span');
        line.className = 'project-title__line';
        line.textContent = lineText;
        title.append(line);
      });

      const longestLine = Math.max(
        ...[...title.querySelectorAll('.project-title__line')].map((line) => line.getBoundingClientRect().width)
      );

      if (!longestLine) return;

      const fittedSize = Math.max(12, baseFontSize * (targetWidth / longestLine));
      title.style.fontSize = `${fittedSize.toFixed(2)}px`;
    });

    if (projectPageHeading && projectTitles[0]) {
      projectPageHeading.style.fontSize = getComputedStyle(projectTitles[0]).fontSize;
    }
  };

  const fitProjectSubtitles = () => {
    projectSubtitles.forEach((subtitle) => {
      const originalText = subtitle.dataset.fitText || subtitle.textContent.trim();
      subtitle.dataset.fitText = originalText;
      subtitle.textContent = originalText;
      subtitle.style.removeProperty('font-size');

      const targetWidth = subtitle.clientWidth;
      const baseFontSize = Number.parseFloat(getComputedStyle(subtitle).fontSize);

      if (!targetWidth || !baseFontSize || !originalText) return;

      const line = document.createElement('span');
      line.className = 'project-subtitle__line';
      line.textContent = originalText;
      subtitle.textContent = '';
      subtitle.append(line);

      const lineWidth = line.getBoundingClientRect().width;

      if (!lineWidth) return;

      const fittedSize = Math.max(10, baseFontSize * (targetWidth / lineWidth));
      subtitle.style.fontSize = `${fittedSize.toFixed(2)}px`;
    });
  };

  fitProjectTitles();
  fitProjectSubtitles();

  if (!reduceMotion) {
    firstProjectRow.classList.add('showcase-row--first', 'showcase-row--first-reveal');

    prepareProjectTyping = () => {
      document.querySelectorAll('.showcase-row:not(.showcase-row--first) .showcase-row__content h2, .showcase-row:not(.showcase-row--first) .showcase-row__subtitle').forEach((item) => {
        const textContainers = item.matches('h2')
          ? [...item.querySelectorAll('.project-title__line')]
          : [...item.querySelectorAll('.project-subtitle__line')];

        item.setAttribute('aria-label', item.dataset.fitText || item.textContent.trim());

        textContainers.forEach((container) => {
          const text = container.textContent;
          const visualText = document.createElement('span');

          container.textContent = '';
          visualText.className = 'project-type__visual';
          visualText.setAttribute('aria-hidden', 'true');

          [...text].forEach((character) => {
            if (character === ' ') {
              visualText.append(document.createTextNode(' '));
              return;
            }

            const characterElement = document.createElement('span');
            characterElement.className = 'project-type__char';
            characterElement.textContent = character;
            visualText.append(characterElement);
          });

          container.append(visualText);
        });
      });
    };

    prepareProjectTyping();

    const revealRows = [...projectRows].slice(1).map((row) => {
      row.classList.add('showcase-row--scroll-reveal');
      const direction = row.classList.contains('showcase-row--text-first') ? -1 : 1;
      const items = [...row.querySelectorAll('.showcase-row__reveal')];

      items.forEach((item) => {
        if (!item.matches('h2, .showcase-row__subtitle')) {
          item.classList.add('project-line-reveal');
          if (direction === 1) item.classList.add('project-line-reveal--from-right');
        }
      });

      return {
        row,
        direction,
        media: row.querySelector('.showcase-row__media'),
        items
      };
    });

    let revealFrame;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => firstProjectRow.classList.add('is-load-visible'));
    });
    window.setTimeout(() => firstProjectRow.classList.add('is-scroll-ready'), 1100);

    const updateProjectReveal = () => {
      revealFrame = null;

      const viewportHeight = window.innerHeight;
      const revealDistance = viewportHeight * 0.85;
      const mobileProjectLayout = window.innerWidth <= 900;
      const textTriggerPoint = mobileProjectLayout ? 1.35 : 1.16;

      const firstFadeDistance = Math.max(firstProjectRow.offsetHeight * 1.05, viewportHeight * 0.35);
      const firstProgress = clamp(window.scrollY / firstFadeDistance, 0, 1);
      const firstEasedProgress = firstProgress * firstProgress * (3 - 2 * firstProgress);

      firstProjectRow.style.setProperty('--project-first-opacity', (1 - firstEasedProgress).toFixed(4));
      firstProjectRow.style.setProperty('--project-first-y', `${(-firstEasedProgress * 32).toFixed(2)}px`);

      revealRows.forEach(({ row, direction, media, items }) => {
        const firstItemRect = items[0]?.getBoundingClientRect();
        const lastItemRect = items[items.length - 1]?.getBoundingClientRect();
        const textMiddle = firstItemRect && lastItemRect
          ? (firstItemRect.top + lastItemRect.bottom) / 2
          : row.getBoundingClientRect().top;
        const rowProgress = clamp((viewportHeight * textTriggerPoint - textMiddle) / revealDistance, 0, 1);
        const mediaRect = media?.getBoundingClientRect();
        const mediaTop = mediaRect?.top ?? row.getBoundingClientRect().top;
        const mediaProgress = mobileProjectLayout
          ? clamp((viewportHeight * 1.32 - mediaTop) / (viewportHeight * 0.85), 0, 1)
          : clamp(rowProgress, 0, 1);
        const mediaEasedProgress = mediaProgress * mediaProgress * mediaProgress * (mediaProgress * (mediaProgress * 6 - 15) + 10);
        const mediaFrameDistance = mobileProjectLayout ? 16 : 48;
        const mediaDistance = mobileProjectLayout ? 20 : 48;
        const mediaZoom = mobileProjectLayout ? 0.05 : 0.15;
        const mediaFrameOffset = -direction * (1 - mediaEasedProgress) * mediaFrameDistance;
        const mediaOffset = -direction * (1 - mediaEasedProgress) * mediaDistance;
        const mediaScale = 1 + (1 - mediaEasedProgress) * mediaZoom;

        media?.style.setProperty('--media-frame-x', `${mediaFrameOffset.toFixed(2)}px`);
        media?.style.setProperty('--media-reveal-x', `${mediaOffset.toFixed(2)}px`);
        media?.style.setProperty('--media-reveal-scale', mediaScale.toFixed(4));

        items.forEach((item, index) => {
          const itemDelay = Math.min(index * 0.05, 0.3);
          const itemProgress = clamp((rowProgress - itemDelay) / (1 - itemDelay), 0, 1);
          const easedProgress = itemProgress * itemProgress * itemProgress * (itemProgress * (itemProgress * 6 - 15) + 10);
          const offset = direction * (1 - easedProgress) * 72;

          item.style.setProperty('--reveal-x', `${offset.toFixed(2)}px`);

          if (item.classList.contains('project-line-reveal')) {
            item.style.setProperty('--project-line-hidden', `${((1 - itemProgress) * 100).toFixed(2)}%`);
          } else {
            const characters = [...item.querySelectorAll('.project-type__visual')].flatMap((visualText) => {
              const lineCharacters = [...visualText.querySelectorAll('.project-type__char')];
              return direction === 1 ? lineCharacters.reverse() : lineCharacters;
            });

            characters.forEach((character, characterIndex) => {
              const characterProgress = clamp(itemProgress * (characters.length + 3) - characterIndex, 0, 1);
              character.style.setProperty('--project-type-opacity', characterProgress.toFixed(4));
            });
          }
        });
      });

      revealRows.forEach(({ row }) => {
        const rect = row.getBoundingClientRect();
        row.toggleAttribute('data-reveal-active', rect.bottom > 0 && rect.top < viewportHeight);
      });
    };

    requestProjectReveal = () => {
      if (revealFrame) return;
      revealFrame = requestAnimationFrame(updateProjectReveal);
    };

    updateProjectReveal();
    window.addEventListener('scroll', requestProjectReveal, { passive: true });
    window.addEventListener('pageshow', requestProjectReveal);
  }

  let projectResizeFrame;
  const refreshProjectLayout = () => {
    if (projectResizeFrame) cancelAnimationFrame(projectResizeFrame);

    projectResizeFrame = requestAnimationFrame(() => {
      projectResizeFrame = null;
      fitProjectTitles();
      fitProjectSubtitles();
      if (!reduceMotion) prepareProjectTyping();
      requestProjectReveal();
    });
  };

  window.addEventListener('resize', refreshProjectLayout);
  document.fonts?.ready.then(refreshProjectLayout);
}

const productShowcaseRows = [...document.querySelectorAll('.product-showcase-row')];

if (productShowcaseRows.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);
  const firstProductRow = productShowcaseRows[0];
  const animatedProductRows = productShowcaseRows.slice(1).map((row) => {
    const direction = row.classList.contains('product-showcase-row--text-first') ? -1 : 1;
    const title = row.querySelector('[data-product-type]');
    const lineItems = [...row.querySelectorAll('[data-product-line]')];
    const items = [...row.querySelectorAll('.product-showcase-row__reveal')];

    if (title) {
      const text = title.textContent.trim();
      const visualText = document.createElement('span');

      title.setAttribute('aria-label', text);
      title.textContent = '';
      visualText.className = 'product-showcase-row__type-visual';
      visualText.setAttribute('aria-hidden', 'true');

      [...text].forEach((character) => {
        if (character === ' ') {
          visualText.append(document.createTextNode(' '));
          return;
        }

        const characterElement = document.createElement('span');
        characterElement.className = 'product-showcase-row__type-char';
        characterElement.textContent = character;
        visualText.append(characterElement);
      });

      title.append(visualText);
    }

    lineItems.forEach((item) => {
      item.classList.add('product-showcase-row__line-reveal');
      if (direction === 1) item.classList.add('product-showcase-row__line-reveal--from-right');
    });

    row.classList.add('product-showcase-row--scroll-reveal');

    return {
      row,
      direction,
      media: row.querySelector('.product-showcase-row__media'),
      title,
      items
    };
  });

  firstProductRow.classList.add('product-showcase-row--first-reveal');
  requestAnimationFrame(() => requestAnimationFrame(() => firstProductRow.classList.add('is-load-visible')));
  window.setTimeout(() => firstProductRow.classList.add('is-scroll-ready'), 1100);

  let productRevealFrame;

  const updateProductShowcaseReveal = () => {
    productRevealFrame = null;
    const viewportHeight = window.innerHeight;
    const mobileLayout = window.innerWidth <= 900;
    const firstFadeDistance = Math.max(firstProductRow.offsetHeight * 1.05, viewportHeight * 0.35);
    const firstProgress = clamp(window.scrollY / firstFadeDistance, 0, 1);
    const firstEasedProgress = firstProgress * firstProgress * (3 - 2 * firstProgress);

    firstProductRow.style.setProperty('--product-first-opacity', (1 - firstEasedProgress).toFixed(4));
    firstProductRow.style.setProperty('--product-first-y', `${(-firstEasedProgress * 32).toFixed(2)}px`);

    animatedProductRows.forEach(({ row, direction, media, title, items }) => {
      const firstItemRect = items[0]?.getBoundingClientRect();
      const lastItemRect = items[items.length - 1]?.getBoundingClientRect();
      const textMiddle = firstItemRect && lastItemRect
        ? (firstItemRect.top + lastItemRect.bottom) / 2
        : row.getBoundingClientRect().top;
      const textTriggerPoint = mobileLayout ? 1.2 : 0.68;
      const revealDistance = viewportHeight * (mobileLayout ? 0.75 : 0.36);
      const rowProgress = clamp((viewportHeight * textTriggerPoint - textMiddle) / revealDistance, 0, 1);
      const mediaRect = media?.getBoundingClientRect();
      const mediaTop = mediaRect?.top ?? row.getBoundingClientRect().top;
      const mediaProgress = mobileLayout
        ? clamp((viewportHeight * 1.22 - mediaTop) / (viewportHeight * 0.75), 0, 1)
        : rowProgress;
      const mediaEasedProgress = mediaProgress * mediaProgress * mediaProgress * (mediaProgress * (mediaProgress * 6 - 15) + 10);
      const mediaFrameDistance = mobileLayout ? 16 : 48;
      const mediaDistance = mobileLayout ? 20 : 48;
      const mediaZoom = mobileLayout ? 0.05 : 0.15;

      media?.style.setProperty('--product-media-frame-x', `${(-direction * (1 - mediaEasedProgress) * mediaFrameDistance).toFixed(2)}px`);
      media?.style.setProperty('--product-media-x', `${(-direction * (1 - mediaEasedProgress) * mediaDistance).toFixed(2)}px`);
      media?.style.setProperty('--product-media-scale', (1 + (1 - mediaEasedProgress) * mediaZoom).toFixed(4));

      items.forEach((item, index) => {
        const itemDelay = Math.min(index * 0.08, 0.2);
        const itemProgress = clamp((rowProgress - itemDelay) / (1 - itemDelay), 0, 1);
        const easedProgress = itemProgress * itemProgress * itemProgress * (itemProgress * (itemProgress * 6 - 15) + 10);

        item.style.setProperty('--product-reveal-x', `${(direction * (1 - easedProgress) * 72).toFixed(2)}px`);

        if (item === title) {
          const characters = [...item.querySelectorAll('.product-showcase-row__type-char')];
          const orderedCharacters = direction === 1 ? characters.reverse() : characters;

          orderedCharacters.forEach((character, characterIndex) => {
            const characterProgress = clamp(itemProgress * (orderedCharacters.length + 3) - characterIndex, 0, 1);
            character.style.setProperty('--product-char-opacity', characterProgress.toFixed(4));
          });
        } else {
          item.style.setProperty('--product-line-hidden', `${((1 - itemProgress) * 100).toFixed(2)}%`);
        }
      });
    });
  };

  const requestProductShowcaseReveal = () => {
    if (productRevealFrame) return;
    productRevealFrame = requestAnimationFrame(updateProductShowcaseReveal);
  };

  updateProductShowcaseReveal();
  window.addEventListener('scroll', requestProductShowcaseReveal, { passive: true });
  window.addEventListener('resize', requestProductShowcaseReveal);
  window.addEventListener('pageshow', requestProductShowcaseReveal);
}
